import React from 'react';
import groupChild from '../../img/group-child.png';
import singleChild from '../../img/single-child.png';
import imgChild from '../../img/img-child.png';
import childBigImg from '../../img/child-big-img.png';

const GoalGallerySection = () => {
    return (
        <>
            <section className="help-goal">
                <div className="container">
                    <div className="help-goal-flex">
                        <div className="about-left">
                            <h4>About Us</h4>
                            <h2 className="about-title"><span>Help is Our </span>Main Goal Ever</h2>
                            <a href="/" className="more-about">More About</a>
                        </div>

                        <div className="about-center-content">
                            <h5 className="about-title-ct">Thresher shark rudd African lungfish silverside, Red salmon rockfish
                                grunion, garpike zebra danio
                                king-of-the-salmon banjo catfish.</h5>
                            <p className="about-p">Sea chub demoiselle whalefish zebra lionfish mud cat pelican eel. Minnow
                                snoek icefish velvet-belly shark, California
                                halibut round stingray northern sea robin. Southern grayling trout-perch</p>

                            <p className="about-p">Sharksucker sea toad candiru rocket danio tilefish stingray deepwater
                                stingray Sacramento splittail, Canthigaster rostrata.
                                Midshipman dartfish Modoc sucker, yellowtail kingfish basslet. Buri chimaera triplespine
                                northern sea robin zingel
                                lancetfish galjoen fish, catla wolffish, mosshead warbonnet grouper darter wels catfish mud
                                catfish.</p>

                            <div className="prople-help-flex">

                                <div className="people-help-bx">
                                    <h3 className="tile-people">People We Helped on 2024</h3>
                                    <span className="number-help">200K</span>
                                </div>


                                <div className="people-help-bx">
                                    <h3 className="tile-people">Dollars We Collected</h3>
                                    <span className="number-help">65bil</span>
                                </div>

                                <div className="people-help-bx">
                                    <h3 className="tile-people">Closed Projeccts</h3>
                                    <span className="number-help">100+</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="gallery-overlay">
                <div className="gallery-flex">
                    <div className="image-overlay">
                        <img src={groupChild} alt="Avatar" className="image" />
                        <div className="overlay">
                            <div className="overlay-text">
                                <h2 className="gallery-title">Helpo for Help</h2>
                                <p className="gallery-text">Gray eel-catfish longnose whiptail catfish smalleye squaretail queen
                                    danio unicorn
                                    fish shortnose greeneye fusilier fish silver carp</p>
                                <span className="price-goal"><strong>Goal:</strong> 25 000$</span>
                                <span className="date-goal"> <strong>Date:</strong> 23 Jan'19</span>

                            </div>
                        </div>
                    </div>

                    <div className="image-overlay">
                        <img src={imgChild} alt="Avatar" className="image" />
                        <div className="overlay">
                            <div className="overlay-text">
                                <h2 className="gallery-title">Helpo for Help</h2>
                                <p className="gallery-text">Gray eel-catfish longnose whiptail catfish smalleye squaretail queen
                                    danio unicorn
                                    fish shortnose greeneye fusilier fish silver carp</p>
                                <span className="price-goal"><strong>Goal:</strong> 25 000$</span>
                                <span className="date-goal"> <strong>Date:</strong> 23 Jan'19</span>

                            </div>
                        </div>
                    </div>

                    <div className="image-overlay">

                        <img src={groupChild} alt="Avatar" className="image" />
                        <div className="overlay">
                            <div className="overlay-text">
                                <h2 className="gallery-title">Helpo for Help</h2>
                                <p className="gallery-text">Gray eel-catfish longnose whiptail catfish smalleye squaretail queen
                                    danio unicorn
                                    fish shortnose greeneye fusilier fish silver carp</p>
                                <span className="price-goal"><strong>Goal:</strong> 25 000$</span>
                                <span className="date-goal"> <strong>Date:</strong> 23 Jan'19</span>

                            </div>
                        </div>
                    </div>

                    <div className="image-overlay">
                        <img src={singleChild} alt="Avatar" className="image" />
                        <div className="overlay">
                            <div className="overlay-text">
                                <h2 className="gallery-title">Helpo for Help</h2>
                                <p className="gallery-text">Gray eel-catfish longnose whiptail catfish smalleye squaretail queen
                                    danio unicorn
                                    fish shortnose greeneye fusilier fish silver carp</p>
                                <span className="price-goal"><strong>Goal:</strong> 25 000$</span>
                                <span className="date-goal"> <strong>Date:</strong> 23 Jan'19</span>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-gallery-overlay">
                    <div className="btm-gallery-flex">
                        <div className="image-overlay">
                            <img src={singleChild} alt="Avatar" className="image" />
                            <div className="overlay">
                                <div className="overlay-text">
                                    <h2 className="gallery-title">Helpo for Help</h2>
                                    <p className="gallery-text">Gray eel-catfish longnose whiptail catfish smalleye squaretail
                                        queen danio unicorn
                                        fish shortnose greeneye fusilier fish silver carp</p>
                                    <span className="price-goal"><strong>Goal:</strong> 25 000$</span>
                                    <span className="date-goal"> <strong>Date:</strong> 23 Jan'19</span>
                                </div>
                            </div>
                        </div>
                        <div className="gallery-img-full">
                            <span> <img src={childBigImg} alt='' /></span>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default GoalGallerySection;
